import { useSelector } from "@shared/hooks/shared/useTypedSelector";
import bonusesReducer from "@shared/reducers/bonuses";

export const useBonuses = () => {
  return useSelector(
    ({ bonuses }: TRootState) => bonuses as ReturnType<typeof bonusesReducer>
  );
};
